/**
 * Gets and sets persistent (session) client data for V3 chat.
 */
/**
 * package: com.inq.flash.client.control
 * class: PersistenceManager
 * root Object
 * @constructor
 */
com.inq.flash.client.control.PersistenceManager = function() {
	this.getCookieInfo();
};
$hxClasses['com.inq.flash.client.control.PersistenceManager'] = com.inq.flash.client.control.PersistenceManager;
/** @private @type {Array} */
com.inq.flash.client.control.PersistenceManager.__name__ = ["com","inq","flash","client","control","PersistenceManager"];

/**
 * Close
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function Close():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.control.PersistenceManager.Close = function() {
	com.inq.flash.client.control.PersistenceManager.__inst = null;
};


/**
 * reopen
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function reopen():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.control.PersistenceManager.reopen = function() {
	com.inq.flash.client.control.PersistenceManager.__inst = new com.inq.flash.client.control.PersistenceManager();
};


/**
 * ClearValues
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function ClearValues():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.control.PersistenceManager.ClearValues = function() {
	if(com.inq.flash.client.control.PersistenceManager.__inst != null) com.inq.flash.client.control.PersistenceManager.__inst.clearValues();
};


/**
 * GetValue
 *
 * $type TFun([{ name => label, t => TInst(String,[]), opt => false },{ name => defaultVal, t => TDynamic(null), opt => false }],TDynamic(null))
 * public static function GetValue(label:String, defaultVal:Dynamic):Dynamic
 * @public
 * @static
 * @param {string}  label 
 * @param {null}  defaultVal 
 * @return {*|null}
 */
com.inq.flash.client.control.PersistenceManager.GetValue = function(label,defaultVal) {
	if(com.inq.flash.client.control.PersistenceManager.__inst != null) return com.inq.flash.client.control.PersistenceManager.__inst.getValue(label,defaultVal);
	return defaultVal;
};


/**
 * SetValue
 * Sets a property. Stores it in the cache and saves to underlying persistent layer (cookies).
 * Otherwise we MUST clone objects returned by GetValue() before changing them,
 * because GetValue() returns REFERENCE to value in the cache.
 * When changing cookies in batch, use "true" for last setValue() call and "false" for others.
 *
 * $type TFun([{ name => label, t => TInst(String,[]), opt => false },{ name => val, t => TDynamic(null), opt => false },{ name => force, t => TEnum(Bool,[]), opt => true },{ name => updateCookies, t => TEnum(Bool,[]), opt => true }],TEnum(Void,[]))
 * public static function SetValue(label:String, val:Dynamic, ?force:Bool=false, ?updateCookies:Bool=true):Void
 * @public
 * @static
 * @param {string}  label -            property name 
 * @param {null}  val -              property value 
 * @param {boolean}  force -            flag to force cookie saving even if old & new values are equal. 
 * @param {boolean}  updateCookies -    whether to save the property to cookies. 
 * @return {void}
 */
com.inq.flash.client.control.PersistenceManager.SetValue = function(label,val,force,updateCookies) {
	if(updateCookies == null) updateCookies = true;
	if(force == null) force = false;
	if(com.inq.flash.client.control.PersistenceManager.__inst != null) com.inq.flash.client.control.PersistenceManager.__inst.setValue(label,val,force,updateCookies);
};

/**
 * DeleteValue
 * Delete a property.Which is Stored it in the cache and  underlying persistent layer (cookies).
 * public static function DeleteValue(label:String, ?updateCookies:Bool=true):Void
 * @public
 * @static
 * @param {string}  label -            property name
 * @param {boolean} updateCookies -    whether to save the property to cookies.
 * @return {void}
 */
com.inq.flash.client.control.PersistenceManager.DeleteValue = function (label, updateCookies) {
	if (updateCookies == null) {
		updateCookies = true;
	}

	if (com.inq.flash.client.control.PersistenceManager.__inst != null) {
		com.inq.flash.client.control.PersistenceManager.__inst.deleteValue(label, updateCookies);
	}
};

/**
 * SetValues
 *
 * $type TFun([{ name => map, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * public static function SetValues(map:Dynamic):Void
 * @public
 * @static
 * @param {null}  map 
 * @return {void}
 */
com.inq.flash.client.control.PersistenceManager.SetValues = function(map) {
	if(com.inq.flash.client.control.PersistenceManager.__inst != null) com.inq.flash.client.control.PersistenceManager.__inst.setValues(map);
};

/**
 * createInstance
 *
 * $type TFun([],TInst(com.inq.flash.client.control.PersistenceManager,[]))
 * private static function createInstance():PersistenceManager
 * @private
 * @static
 * @return {com.inq.flash.client.control.PersistenceManager}
 */
com.inq.flash.client.control.PersistenceManager.createInstance = function() {
	return new com.inq.flash.client.control.PersistenceManager();
};


/**
 * setCookieInfo
 *
 * $type TFun([],TEnum(Void,[]))
 * private function setCookieInfo():Void
 * @private
 * @this com.inq.flash.client.control.PersistenceManager
 * @return {void}
 */
com.inq.flash.client.control.PersistenceManager.prototype.setCookieInfo = function() {
	com.inq.flash.client.control.FlashPeer.setV3Data(this.dict);/*  chat.save() will be invoked*/
};


/**
 * getCookieInfo
 *
 * $type TFun([],TEnum(Void,[]))
 * private function getCookieInfo():Void
 * @private
 * @this com.inq.flash.client.control.PersistenceManager
 * @return {void}
 */
com.inq.flash.client.control.PersistenceManager.prototype.getCookieInfo = function() {
	this.dict = com.inq.flash.client.control.FlashPeer.getV3Data();
};


/**
 * setValue
 *
 * $type TFun([{ name => label, t => TInst(String,[]), opt => false },{ name => val, t => TDynamic(null), opt => false },{ name => force, t => TEnum(Bool,[]), opt => true },{ name => updateCookies, t => TEnum(Bool,[]), opt => true }],TEnum(Void,[]))
 * private function setValue(label:String, val:Dynamic, ?force:Bool = false, ?updateCookies:Bool=true):Void
 * @private
 * @this com.inq.flash.client.control.PersistenceManager
 * @param {string}  label 
 * @param {null}  val 
 * @param {boolean}  force 
 * @param {boolean}  updateCookies 
 * @return {void}
 */
com.inq.flash.client.control.PersistenceManager.prototype.setValue = function(label,val,force,updateCookies) {
	if(updateCookies == null) updateCookies = true;
	if(force == null) force = false;
	if(force || this.dict[label] != val) {
		this.dict[label] = val;
		if(updateCookies) this.setCookieInfo();
	}
};

/**
 * Delete a value from the PersistanceManager instance
 *
 * @param {string} label - property name to delete
 * @param {boolean} updateCookies - delete the property from cookies too.
 */
com.inq.flash.client.control.PersistenceManager.prototype.deleteValue = function (label, updateCookies) {
	if (updateCookies == null) {
		updateCookies = true;
	}

	if (this.dict[label]) {
		delete this.dict[label];

		if (updateCookies) {
			this.setCookieInfo();
		}
	}
};

/**
 * setValues
 *
 * $type TFun([{ name => map, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * private function setValues(map:Dynamic):Void
 * @private
 * @this com.inq.flash.client.control.PersistenceManager
 * @param {?Object} map
 * @return {void}
 */
com.inq.flash.client.control.PersistenceManager.prototype.setValues = function (map) {
	/** @type {Array} */
	var keyz = com.inq.utils.Util.fields(map);
	for (var i = 0; i < keyz.length; i++) {
		var k = "" + keyz[i];
		this.dict[k] = map[k];
	}
	com.inq.flash.client.control.FlashPeer.setV3Data(this.dict);
};

/**
 * getValue
 *
 * $type TFun([{ name => label, t => TInst(String,[]), opt => false },{ name => defaultVal, t => TDynamic(null), opt => false }],TDynamic(null))
 * private function getValue(label:String, defaultVal:Dynamic):Dynamic
 * @private
 * @this com.inq.flash.client.control.PersistenceManager
 * @param {string}  label 
 * @param {null}  defaultVal 
 * @return {null}
 */
com.inq.flash.client.control.PersistenceManager.prototype.getValue = function(label,defaultVal) {
	/** @type {?string} */
	var value = this.dict[label];
	if(null == value) value = defaultVal;
	haxe.Log.trace("value [" + label + "]:" + Std.string(value),{ fileName : "PersistenceManager.hx", lineNumber : 56, className : "com.inq.flash.client.control.PersistenceManager", methodName : "getValue"});
	return value;
};


/**
 * clearValues
 *
 * $type TFun([],TEnum(Void,[]))
 * private function clearValues():Void
 * @private
 * @this com.inq.flash.client.control.PersistenceManager
 * @return {void}
 */
com.inq.flash.client.control.PersistenceManager.prototype.clearValues = function() {
	this.dict = { };
	this.setCookieInfo();
};

/** @private @type {null} */
com.inq.flash.client.control.PersistenceManager.prototype.dict = null;

/** @type {com.inq.flash.client.control.PersistenceManager} */
com.inq.flash.client.control.PersistenceManager.prototype.__class__ = com.inq.flash.client.control.PersistenceManager;

/** @private @type {com.inq.flash.client.control.PersistenceManager} */
com.inq.flash.client.control.PersistenceManager.__inst = com.inq.flash.client.control.PersistenceManager.createInstance();

